var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-body"},[_c('TopNavbar',{attrs:{"title":"登录"}}),_c('div',{staticClass:"login-card-container"},[_c('LoginCard',{on:{"loginSuccess":_vm.onLoginSuccess}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }